import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { patchMenuLink, } from 'redux/menu-links/actions';
import { Checkbox } from 'semantic-ui-react';


function MenuLinkIsPublished(props) {
  const {linkItem, patchMenuLink, error} = props;
  const isDisabled = error || linkItem.menu_items.length < 1 || !linkItem.menu_items[0].description.length;

  const onCheckboxChange = (_e, { checked }) => {
    const form = new FormData();
    form.append('is_published', checked);
    patchMenuLink(linkItem.id, form);
  };
  
  return (
    <div className="menu-link-is-published__component">
      <Checkbox
        toggle
        checked={isDisabled ? false : linkItem.is_published }
        onChange={onCheckboxChange}
        disabled={isDisabled}
      />
    </div>
  );
}

MenuLinkIsPublished.propTypes = {
  linkItem: PropTypes.object.isRequired, 
  patchMenuLink: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
}

export default connect(null, {patchMenuLink,}) (MenuLinkIsPublished);